import { type FC } from "react";

import { Colors } from "@snapchat/snap-design-system";

import { StatusCell } from "../../camkit/common/components/table/StatusCell";
import { DecreaseText } from "../../camkit/common/components/text";
import { HostedLensStatus } from "../../gql-generated/types";

import { CellWrapper, textCss } from "./HostedLensStatusCell.styles";

interface HostedLensStatusCellProps {
    status?: string;
    content?: string;
}

const statusLabelMap: Record<string, { text: string; color: string }> = {
    [HostedLensStatus.HostedLensStatusPublished]: { text: "Published", color: Colors.Green.V150 },
    [HostedLensStatus.HostedLensStatusDraft]: { text: "Draft", color: Colors.Orange.V200 },
    [HostedLensStatus.HostedLensStatusUnpublished]: { text: "Unpublished", color: Colors.Gray.V300 },
    [HostedLensStatus.HostedLensStatusUnset]: { text: "Unpublished", color: Colors.Gray.V300 },
};

export const HostedLensStatusCell: FC<HostedLensStatusCellProps> = ({ status, content }) => (
    <CellWrapper>
        {status && <StatusCell status={status} statusMap={statusLabelMap} />}
        {content && <DecreaseText className={textCss}>{content}</DecreaseText>}
    </CellWrapper>
);
